import * as v from 'valibot'
import { createServerFn } from '@tanstack/react-start'
import type { BlogResponse } from '@/interfaces'
import { api } from '@/lib/connectivity.ts'

const searchParamsSchema = v.object({
	page: v.optional(v.number()),
	url: v.optional(v.string()),
})

export const getBlogs = createServerFn({
	method: 'GET',
	response: 'data',
})
	.validator((data: v.InferInput<typeof searchParamsSchema>) => v.parse(searchParamsSchema, data))
	.handler(
		async ({ data: { page, url } }) =>
			await api
				.get<BlogResponse>('/blogs', {
					params: {
						url,
						page: page || 1,
					},
				})
				.then(({ data }) => data.body),
	)
